import React, { Component } from "react";
import {
  Typography,
  Paper,
  Tabs as Tabs1,
  Tab as Tab1,
} from "@material-ui/core";
import { GetData } from "../../api/service";
import AcademicAbout from "../Academics/AcademicAbout";
import CollegeNotificationShort from "../College/CollegeNotificationShort";

const smallTab = [
  {
    title: "Policies, Regulations and Guidelines",
    active: 0,
  },
  {
    title: "Schemes",
    active: 1,
  },
  {
    title: "Annual Apprenticeship Reports",
    active: 2,
  },
  {
    title: "Annual Activity Report",
    active: 3,
  },
  {
    title: "Compliance Reports",
    active: 4,
  },
  {
    title: "Special Reports",
    active: 5,
  },
];

class ApprenticeshipDivisionHomeLanding extends Component {
  state = {
    active: 0,
    dept_code: "DISPUR",

    data: {},
    isDeptLoaded: false,
  };

  __getDeptData = (dept_code) => {
    GetData(`/admin/${dept_code}/getsingledeptdata`).then((resp) => {
      if (resp != false) {
        this.setState({
          data: resp,
          active: 0,
          isDeptLoaded: true,
        });
      } else {
        this.setState({
          data: {},
          active: 0,
          isDeptLoaded: true,
        });
      }
    });
  };

  componentDidMount() {
    this.__getDeptData(this.state.dept_code);
  }

  render() {
    return (
      <div>
        <Typography variant="h6">Apprenticeship Division</Typography>
        <Typography variant="subtitle2">
          Code: {this.state.dept_code}
        </Typography>

        <br />

        {this.state.isDeptLoaded && (
          <Paper square>
            <Tabs1
              value={this.state.active}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              onChange={(e, newValue) =>
                this.setState({
                  active: newValue,
                })
              }
              aria-label=""
            >
              {smallTab.map((el, index) => (
                <Tab1 value={el.active} key={el.active} label={el.title} />
              ))}
            </Tabs1>
          </Paper>
        )}
        <br />

        {this.state.active == 0 ? (
          <AcademicAbout
            type={`APPRENTICESHIP_DIV_POLICIES`}
            title="Policies, Regulations and Guidelines"
          />
        ) : null}

        {this.state.active == 1 ? (
          <CollegeNotificationShort
            type={`APPRENTICESHIP_DIV_SCHEMES`}
            title="Schemes"
          />
        ) : null}

        {this.state.active == 2 ? (
          <CollegeNotificationShort
            type={`APPRENTICESHIP_DIV_ANNUAL_REPORTS`}
            title="Annual Apprenticeship Reports"
          />
        ) : null}

        {this.state.active == 3 ? (
          <CollegeNotificationShort
            type={`APPRENTICESHIP_DIV_ACTIVITY_REPORT`}
            title="Annual Activity Report"
          />
        ) : null}

        {this.state.active == 4 ? (
          <CollegeNotificationShort
            type={`APPRENTICESHIP_DIV_COMPLIANCE_REPORTS`}
            title="Compliance Reports"
          />
        ) : null}

        {this.state.active == 5 ? (
          <CollegeNotificationShort
            type={`APPRENTICESHIP_DIV_SPECIAL_REPORTS`}
            title="Special Reports"
          />
        ) : null}
      </div>
    );
  }
}

export default ApprenticeshipDivisionHomeLanding;
